import { Button } from '@/components/button';

/**
 * The way back into the flow the user left. Recovery is reached by a full
 * same-tab navigation OUT of a live interaction, and neither page offered any
 * route back — in an in-app browser with no Back control, one mistaken tap on
 * "Forgot your password?" abandoned the sign-in even though the interaction
 * was still alive. history.back() lands on /interaction/:uid, whose state now
 * resumes the step the user was on.
 *
 * Rendered only when there IS somewhere to go back to: a user who opened the
 * emailed reset link directly has no flow behind them.
 */
export function BackToSignIn({ label }: { label: string }) {
  if (window.history.length <= 1) return null;
  return (
    <div className="mt-6 text-center">
      <Button
        type="button"
        variant="link"
        onClick={() => window.history.back()}
      >
        {label}
      </Button>
    </div>
  );
}
